import { useMutation } from '@apollo/client'

import { graphene } from 'graphql/tags'

const batchUpdateOrderRetailerAccount = graphene`#graphql
  mutation BatchUpdateOrderRetailerAccount(
    $input: BatchUpdateOrderRetailerAccountInput!
  ) {
    batchUpdateOrderRetailerAccount(input: $input) {
      updatedOrders {
        id
      }
      notUpdatedOrders {
        id
      }
    }
  }
`

export function useAssignRetailerMutation() {
  const [mutation, { loading }] = useMutation(batchUpdateOrderRetailerAccount)
  return {
    mutation: (
      orderId: string,
      retailerId: string,
      buyerEmail: string,
      keepAddressInfo: boolean,
    ) => {
      return mutation({
        variables: {
          input: {
            orderIds: [orderId],
            retailerAccountId: retailerId,
            buyerEmailAddress: buyerEmail,
            keepAddressInfo,
          },
        },
      })
    },
    loading,
  }
}
